import { render, staticRenderFns } from "./OrgFeatureStatus.vue?vue&type=template&id=67141630&"
import script from "./OrgFeatureStatus.vue?vue&type=script&lang=js&"
export * from "./OrgFeatureStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports